<template>
  <div>
    <v-hover>
      <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`"
      class="mx-auto related-news-card"
      color="white">
        <router-link :to="{name: 'actuId', params: {actuId: article.slug} }" class="link-img">
          <div class="img-overlay"></div>
          <v-img
          class="white--text"
          height="200px"
          :src="article.acf.image_a_la_une.url"
          :alt="article.acf.image_a_la_une.alt"
          cover
          >
          </v-img>
        </router-link>

        <v-card-title class="news-card__caption-area" v-once>
            <div class="news-card__caption news-card__caption--plain"> <!-- urgent, plain -->
                <span class="news-card__caption-tags">
                  <router-link :to="{name: 'actuId', params: {actuId: article.slug} }" class="tags" :style="{'background-color': tagColor}"> {{ article.acf.categorie.name }}</router-link>
                  <router-link :to="{name: 'actuId', params: {actuId: article.slug} }" class="tags" :style="{'background-color': tagColor}">{{ getTagsStr(article.acf.etiquettes, 2) }}</router-link>
                </span>
                <span class="news-card__caption-pubdate">{{ getPubDateStr(article.date) }}</span>
                <h1 class="news-card__caption-title"><router-link :to="{name: 'actuId', params: {actuId: article.slug} }" v-html="article.title.rendered"></router-link></h1>
                <p class="news-card__caption-summary" v-html="article.excerpt.rendered"></p>
            </div>
        </v-card-title>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import RestApiHelper from '../../../helpers/rest-api-func';

export default {
  data() {
      return {

      }
  },
  props: {
    article: {type: Object, default: function() {return { }; } },
    tagColor: {
      type: String,
      default: "rgba(0, 123, 224, 0.9)"
    }
  },
  methods: {
    getTagsStr(tagList, nbTags) {
      let str = "---";
      let tab = [];
      for (let i = 0; i < Math.min(nbTags, tagList.length); ++i) {
        tab.push(tagList[i].name);
      }
      return tab.join(", ");
    },
    getPubDateStr(rawPubDate) {
      let date_tab = RestApiHelper.getDateTab(rawPubDate);
      let str = date_tab[3] + " "
                + RestApiHelper.getMonth(date_tab[1]) + " "
                + date_tab[0];
    }
  },
  computed: {
    // ...mapState({
    //   articles: state => state.news.articles
    // }),
    // ...mapGetters("news", {
    //   articles: "articles"
    // })
  },
  filters: {
    strFilter: function(value, len) {
      if (value == null) return "";

      if (value.length <= len)
        return value;
      else
        return value.slice(0, len) + "...";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../scss/__base.scss";
// .related-news-card {
//   position: relative;
//   height: 100%;
// }
.news-card {
   &__caption-area {
     background-color: #F4F4F4;
    //  height: auto;
   }
    &__caption {
        margin: 10px;
      & &-title {
        font-size: 1.45rem;
        margin-top: 6px;
        margin-bottom: 4px;
        text-shadow: 0px 1px 1px rgba(#333, 00);
        text-transform: uppercase;

        // display: block;

        &::before {
            content: " "
        }

        & a {
            color: rgba(#000, 0.8);
        }
      }

       &--urgent &-title {
        padding: 3px 10px;
        font-size: 1.4rem;
        color: #eee;

        // background-color: rgba(#05bdff, 0.8);
        & a {
            // color: rgba(#05bdff, 0.8);

        }
        // background-color: rgba(red, 0.8);
        margin-bottom: 5px;
      }

      & &-tags {
        & > a {
          background-color: rgba(grey, 0.2);
          color: rgba(#fff,0.97);
           padding: 1px 4px;
           display: inline-block;
           font-size: 1.2rem;
        }
      }

      & &-pubdate {
        margin-right: 10px;
        font-size: 0.9rem;
        color: #999;
      }

      & &-summary {
        color: #444;
        font-size: 1.4rem;
        line-height: 1.7;
        margin-top: 10px;
        // text-align: justify;
      }
    }
  }

//   a.link-img {
//       position: relative;
//       display: block;
//       width: 100%;
//       height: 100%;
//       background-color: transparent;
//       }
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/RelatedNewsCard.vue